module.exports = __webpack_public_path__ + "static/media/logo.cb6e5f01.png";